import UserProfileSection from '@components/Header/UserProfileSection'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { Box, Container, Theme } from '@mui/material'
import { styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

import headerBackgroundImage from '../../assets/header_background.jpg'
import EventItem from '../EventItem'

export const Root = styled(Box)`
  position: relative;
  padding: 24px 0 48px;
  background-image: url('${headerBackgroundImage}');
  background-size: cover;
  background-position: center;
  min-height: calc(100vh - 94px);
`

export const StyledContainer = styled(Container)`
  max-width: 1028px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const Header = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 36px;

  ${({ theme }: { theme: Theme }) => theme.breakpoints.down('sm')} {
    &::before {
      content: '';
      position: absolute;
      top: 100px;
      left: 0;
      height: 1px;
      width: 100%;
      background-color: ${colors.primaryLight};
    }
  }

  ${({ theme }: { theme: Theme }) => theme.breakpoints.down(400)} {
    &::before {
      top: 92px;
    }
  }
`

export const EventsContainerWrapper = styled('div')<{ theme: Theme }>`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: 100px;

  ${({ theme }: { theme: Theme }) => theme.breakpoints.down('md')} {
    margin-top: 50px;
  }
  ${({ theme }: { theme: Theme }) => theme.breakpoints.down('sm')} {
    margin-top: 0;
  }
`

export const LogoImageWrapper = styled(Box)`
  line-height: 0;
  max-width: 335px;

  ${({ theme }: { theme: Theme }) => theme.breakpoints.down('sm')} {
    max-width: 250px;
  }

  ${({ theme }: { theme: Theme }) => theme.breakpoints.down(400)} {
    max-width: 220px;
  }
`

export const LogoImage = styled('img')`
  width: 100%;
`

export const StyledUserProfileSection = styled(UserProfileSection)`
  margin-left: 32px;

  & .user-profile-button-image {
    width: 65px;
    height: 65px;
    margin-right: 4px;

    ${({ theme }: { theme: Theme }) => theme.breakpoints.down('sm')} {
      width: 52px;
      height: 52px;
    }

    ${({ theme }: { theme: Theme }) => theme.breakpoints.down(400)} {
      width: 45px;
      height: 45px;
    }
  }

  & .user-profile-button-arrow {
    font-size: 36px;

    ${({ theme }: { theme: Theme }) => theme.breakpoints.down('sm')} {
      font-size: 30px;
    }

    ${({ theme }: { theme: Theme }) => theme.breakpoints.down(400)} {
      font-size: 24px;
    }
  }
`

export const WelcomeToLabel = styled(Box)`
  font-family: Poppins;
  font-weight: 400;
  font-size: 32px;
`

export const P1EventsLogo = styled('img')`
  width: 100%;
  max-width: 302px;
`

export const WelcomeToContainer = styled(Box)`
  margin-bottom: 32px;

  ${({ theme }: { theme: Theme }) => theme.breakpoints.down('sm')} {
    padding-top: 20px;
    margin-bottom: 12px;
  }
`

export const EventsContainer = styled(Box)`
  display: flex;

  ${({ theme }: { theme: Theme }) => theme.breakpoints.down('sm')} {
    flex-direction: column;
  }
`

export const EventsContainerPart = styled(Box)`
  width: 50%;

  ${({ theme }: { theme: Theme }) => theme.breakpoints.down('sm')} {
    width: 100%;
  }
`

export const CurrentEventsContainer = styled(Box)``

export const EventTile = styled(EventItem)<{ $minWidth?: string; $marginBottom?: string }>`
  max-width: 388px;

  ${({ theme }: { theme: Theme }) => theme.breakpoints.down('sm')} {
    margin: 0 auto 20px;
  }

  ${({ $minWidth, $marginBottom }) =>
    $minWidth && $marginBottom
      ? `
          min-width: ${$minWidth};
          margin-bottom: ${$marginBottom};
        `
      : ''}
`

export const EventTileLabelContainer = styled(Box)`
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  background-color: ${colors.primary};
  padding: 0 16px;
  height: 43px;
`

export const EventPaginationBlock = styled('div')`
  display: flex;
  gap: 14px;
  align-items: center;
`

export const EventPaginationDot = styled('div')`
  width: 19px;
  height: 19px;
  border-radius: 50%;
  cursor: pointer;
  background-color: ${({ $isActive }: { $isActive: boolean }) => ($isActive ? '#0B7CB7' : '#AEC7D2')};
`

export const EventTileLabelText = styled(Box)`
  color: ${colors.white};
`

export const EventTileGoToLabel = styled(Box)`
  display: inline;
  font-family: Poppins;
  font-size: 16px;
  font-weight: 400;

  ${({ theme }: { theme: Theme }) => theme.breakpoints.down('sm')} {
    font-size: 14px;
  }
`

export const EventTileEventPartneringLabel = styled(Box)`
  display: inline;
  background-color: ${colors.primary};
  font-family: Poppins;
  font-size: 16px;
  font-weight: 600;

  ${({ theme }: { theme: Theme }) => theme.breakpoints.down('sm')} {
    font-size: 14px;
  }
`

export const EventTileLabelArrow = styled(NavigateNextIcon)`
  fill: ${colors.white};
  font-size: 32px;
  margin-left: 5px;
  margin-right: -11px;
`

export const EventDropdownsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-left: 40px;

  ${({ theme }: { theme: Theme }) => theme.breakpoints.down('sm')} {
    padding-left: 0;
    gap: 12px;
  }
`

export const EventsList = styled(Box)`
  overflow: auto;
  width: 420px;
  max-width: 85vw;
  height: 550px;
  padding: 16px;
`

export const EventsListInner = styled('div')`
  display: flex;
  flex-direction: column;
  position: relative;

  ${({ theme }: { theme: Theme }) => theme.breakpoints.down('sm')} {
    gap: 8px;
    padding: 8px;
  }
`

export const EventsListScrollAnchor = styled(Box)`
  border: 1px solid green;
  width: 100px;
  visibility: hidden;
`

export const EventsColumnSeparator = styled('div')<{ theme: Theme }>`
  background: #bfbfbf;
  height: inherit;
  width: 1px;
  margin: 46px 24px 92px;

  ${({ theme }: { theme: Theme }) => theme.breakpoints.down('sm')} {
    width: 100%;
    height: 1px;
    margin: 29px 0;
  }
`

export const EventsLabel = styled('div')`
  background: #e32758;
  padding: 2px 12px;
  color: ${colors.white};
  font-weight: 700;
  font-size: 18px;
  border-radius: 50px;
  width: fit-content;
  margin-bottom: 16px;
`
